/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'
import { ContainedButton, DateInput, EditArea, EditContainer, EditField, EditTitleBar, TextButton, TextInput } from 'ui-library/dist/external/components'
import { EditViewLayout } from 'ui-library/dist/external/layouts'
import HotelAction from '../../../action/hotel'
import { FileInput } from '../../atoms'
import Cell from '../../templates/Cell'

function EditView(props) {
  const hotel = props.hotel
  return (
    <EditViewLayout>
      <EditContainer
        titleBar={<EditTitleBar title={`宿泊施設ID: ${hotel.id || ''}`} />}
        editArea={
          <EditArea
            fields={[
              <EditField key="宿泊施設名">
                <TextInput
                  label="宿泊施設名"
                  fullWidth
                  name="name"
                  value={hotel.name}
                  onChange={e => {
                    HotelAction.onEdit('name', e.target.value)
                  }}
                />
              </EditField>,
              <EditField key={`運営終了日`}>
                <DateInput
                  name="closed_date"
                  label="運営終了日"
                  leadingIcon={'insert_invitation'}
                  fullWidth
                  value={hotel.closed_date}
                  onDateSelect={value => HotelAction.onEdit('closed_date', value)}
                />
              </EditField>,
              <EditField key={`運営終了日をクリア`}>
                <TextButton key="clear-closed-date" onClick={() => HotelAction.onEdit('closed_date', '')}>
                  運営終了日をクリア
                </TextButton>
              </EditField>,
              <EditField key="宿泊約款(PDF)">
                <Cell>
                  宿泊約款(PDF)
                  <FileInput
                    label={hotel.terms_name}
                    name="terms_url"
                    accept="application/pdf"
                    type="pdf"
                    isDisplay={hotel.terms_url ? true : false}
                    onChange={e => HotelAction.onUpload(hotel, e)}
                    onClear={e => HotelAction.onClear(hotel, 'terms')}
                    onDisplay={e => window.open(`${hotel.terms_url}`, '_blank')}
                  />
                </Cell>
              </EditField>
            ]}
          />
        }
        footerItems={[
          <TextButton key="cancel" onClick={() => HotelAction.onCancel()}>
            キャンセル
          </TextButton>,
          <ContainedButton key="save" onClick={() => HotelAction.onRequestUpdate(hotel)}>
            保存
          </ContainedButton>
        ]}
      />
    </EditViewLayout>
  )
}

export default EditView
